import { normalizeAddress, type AddressLike } from '@plato/data/model/address';
import { safeJoin } from '../utils/string-utils.ts';

/**
 * Creates a formatted address string from address data.
 * - Removes redundant address lines (lines in customer_name or street)
 * - Adds proper spacing between street number and postal code
 */
export const getFullAddressString = (
    address: AddressLike,
    customerName?: string,
    delimiter = ', ',
): string => {
    const normalizedAddress = normalizeAddress(address);

    return safeJoin(
        [
            ...[
                normalizedAddress.addressLine1,
                normalizedAddress.addressLine2,
                normalizedAddress.addressLine3,
            ].filter(
                (line) => line && !normalizedAddress.street?.includes(line) && !customerName?.includes(line),
            ),
            normalizedAddress.street,
            safeJoin([normalizedAddress.zipCode, normalizedAddress.city], ' '),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            normalizedAddress.country || normalizedAddress.countryCode,
        ],
        delimiter,
    );
};
